// CartContext.js - UPDATED FOR BACKEND API
import React, { createContext, useContext, useReducer, useEffect } from 'react';
import { useAuth } from './AuthContext';

const CartContext = createContext();

const cartReducer = (state, action) => {
  switch (action.type) {
    case 'LOAD_CART_SUCCESS':
      return {
        ...state,
        cartItems: action.payload || [],
        loading: false,
        error: null
      };
    
    case 'LOAD_CART_ERROR':
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    
    case 'SET_LOADING':
      return { ...state, loading: action.payload };
    
    case 'CLEAR_ERROR':
      return { ...state, error: null };
    
    default:
      return state;
  }
};

const initialState = {
  cartItems: [],
  loading: false,
  error: null
};

export const CartProvider = ({ children }) => {
  const [state, dispatch] = useReducer(cartReducer, initialState);
  const { user } = useAuth();

  // Load cart from backend API
  const fetchCartFromBackend = async () => {
    if (!user) {
      dispatch({ type: 'LOAD_CART_SUCCESS', payload: [] });
      return;
    }

    try {
      dispatch({ type: 'SET_LOADING', payload: true });
      
      const token = localStorage.getItem('token');
      const response = await fetch('https://krishidnya-backend.onrender.com/api/cart', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch cart');
      }

      const result = await response.json();
      
      if (result.success) {
        dispatch({ type: 'LOAD_CART_SUCCESS', payload: result.data.items || [] });
      } else {
        throw new Error(result.message || 'Failed to load cart');
      }
    } catch (error) {
      console.error('Error loading cart from backend:', error);
      dispatch({ type: 'LOAD_CART_ERROR', payload: error.message });
    }
  };

  // Load cart when user changes
  useEffect(() => {
    fetchCartFromBackend();
  }, [user]);

  const value = {
    cartItems: state.cartItems,
    loading: state.loading,
    error: state.error,
    refreshCart: fetchCartFromBackend
  };

  return (
    <CartContext.Provider value={value}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};

export default CartContext;